import { useBraidTheme } from "../BraidProvider/BraidThemeContext.mjs";
const useSpace = () => useBraidTheme().space;
export {
  useSpace
};
